import { render, staticRenderFns } from "./stockWarn.vue?vue&type=template&id=18ad6396&scoped=true&"
import script from "./stockWarn.vue?vue&type=script&lang=js&"
export * from "./stockWarn.vue?vue&type=script&lang=js&"
import style0 from "./stockWarn.vue?vue&type=style&index=0&id=18ad6396&scoped=true&lang=css&"
import style1 from "./stockWarn.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ad6396",
  null
  
)

export default component.exports